import { Typography } from 'antd';
import { Key } from 'antd/lib/table/interface';
import { IPaginationMeta } from 'src/domain/IPagination';
import Table, { ColumnType, TableProps } from 'antd/lib/table';
import { useCustomizableTableContext } from './CustomizableTableContext';
import { getTablePaginationParams } from './getTablePaginationParams';
import { ResizableHeaderCell } from './ResizableHeaderCell';
import './customizable-table.css';

export const CUSTOMIZED_TABLE_CONFIG = {
    minColumnWidth: 70,
    maxColumnWidth: 400,
    defaultColumnWidth: 200,
    nonResizableKeys: ['actions', 'operation', 'selection-column', 'checkbox', 'expand'],
};

export type CustomizableTableConfigKey =
    | 'sites'
    | 'nominations'
    | 'eventPerformance'
    | 'agreementStatuses'
    | 'customerVen'
    | 'cloudVen'
    | 'cmriOverview'
    | 'vendorBillItems'
    | 'eventTracking'
    | 'eventCompanyParticipation'
    | 'nominationReadinessConfirmation'
    | 'nominationReadinessConfirmation'
    | 'pjmLocations'
    | 'pjmRegistrations'
    | 'customerBillReports'
    | 'customerBillFiles';

export interface CustomizableColumnType<T = unknown> extends Omit<ColumnType<T>, 'key'> {
    key: Key;
    order?: number;
    hideable?: boolean;
    hidden?: boolean;
    width?: number;
    onHeaderCell?: any;
    title?: ColumnType<T>['title'];
}

export interface CustomizableTableProps<T = unknown> extends Omit<TableProps<T>, 'loading' | 'columns'> {
    loading: boolean;
    meta: IPaginationMeta;
    showHiddenColumnsCount?: boolean;
}

export const CustomizableTable = <T extends Record<string, any>>({
    loading,
    meta,
    showHiddenColumnsCount = false,
    ...tableProps
}: CustomizableTableProps<T>) => {
    const { columns: contextColumns, hiddenColumnsCount } = useCustomizableTableContext<T>();

    return (
        <>
            {showHiddenColumnsCount && hiddenColumnsCount > 0 && (
                <Typography.Text type="secondary">Hidden Columns: {hiddenColumnsCount}</Typography.Text>
            )}

            <Table<T>
                {...tableProps}
                columns={contextColumns}
                loading={loading}
                pagination={getTablePaginationParams(meta, tableProps.pagination)}
                scroll={{ x: 'scroll' }}
                components={{
                    header: {
                        cell: ResizableHeaderCell,
                    },
                }}
            />
        </>
    );
};
